import { eCheckVoidReason } from 'types/accounting/eCheckVoidReason';
import { eVoidReason } from 'types/accounting/eVoidReason';
import * as yup from 'yup';

const voidBaseSchema = {
  confirmation: yup.boolean().oneOf([true]).required().nullable().label('Confirmation'),
  voidReason: yup.mixed<eCheckVoidReason | eVoidReason>().required().nullable().label('Reason'),
  voidReasonDescription: yup
    .string()
    .when('voidReason', {
      is: eCheckVoidReason.Other,
      then: yup.string().min(3).max(255).required(),
    })
    .when('voidReason', {
      is: eVoidReason.SentInError,
      then: yup.string().required().nullable().label('Sent in Error Reason'),
    })
    .nullable()
    .label('Void Reason Description'),
};

export const voidWireSchema = yup.object().shape({
  ...voidBaseSchema,
});
export const voidACHSchema = yup.object().shape({
  ...voidBaseSchema,
});
export const voidInternalTransferSchema = yup.object().shape({
  ...voidBaseSchema,
});

export const voidCheckSchema = yup.object().shape({
  checkInHand: yup.boolean().required().nullable().label('Check In Hand'),
  ...voidBaseSchema,
});
